import React from 'react'
import ReactDOM from 'react-dom'
import './stylesheets/base.css'

import { ApptRoutes } from './routes'

ReactDOM.render(<ApptRoutes />, document.getElementById('root'))
